// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3mPQ6","title":"ClientReferral_title__25CQc","itemText":"ClientReferral_itemText__W36Gr"};